import {
  PhoneNumberFormat,
  formatPhoneNumberSafe,
} from '@inspiren-monorepo/util-formatters';

export const comparePhoneNumberSafe = (a: string, b: string): boolean =>
  formatPhoneNumberSafe(a, PhoneNumberFormat.E164) ===
  formatPhoneNumberSafe(b, PhoneNumberFormat.E164);
